// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"482":"c1cfa67a","578":"eebf7d46","787":"1c1f5cbf"}[chunkId] + ".chunk.js";
};